"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManagerPageDashboard = void 0;
const endOfDay_1 = __importDefault(require("date-fns/endOfDay"));
const startOfDay_1 = __importDefault(require("date-fns/startOfDay"));
const startOfToday_1 = __importDefault(require("date-fns/startOfToday"));
const firestore_1 = require("firebase/firestore");
const groupBy_1 = __importDefault(require("lodash/groupBy"));
const keys_1 = __importDefault(require("lodash/keys"));
const react_1 = __importStar(require("react"));
const Alert_1 = __importDefault(require("react-bootstrap/Alert"));
const Card_1 = __importDefault(require("react-bootstrap/Card"));
const Col_1 = __importDefault(require("react-bootstrap/Col"));
const Container_1 = __importDefault(require("react-bootstrap/Container"));
const ListGroup_1 = __importDefault(require("react-bootstrap/ListGroup"));
const OverlayTrigger_1 = __importDefault(require("react-bootstrap/OverlayTrigger"));
const Row_1 = __importDefault(require("react-bootstrap/Row"));
const Tooltip_1 = __importDefault(require("react-bootstrap/Tooltip"));
const react_router_dom_1 = require("react-router-dom");
const configContext_1 = require("../../context/configContext");
const BookingStatus_1 = require("../../models/BookingStatus");
const CustomerBooking_1 = require("../../models/CustomerBooking");
const bookingFactory = __importStar(require("../../models/helper/bookingFactory"));
const dateUtils = __importStar(require("../../utils/dateUtils"));
const useFirestore_1 = require("../../utils/useFirestore");
const useQueryString_1 = require("../../utils/useQueryString");
const BookingFilters_1 = require("../booking-filters/BookingFilters");
const IconEmojiPeople_1 = require("../icons/IconEmojiPeople");
const IconHelpOutline_1 = require("../icons/IconHelpOutline");
const IconPeople_1 = require("../icons/IconPeople");
const IconPostAdd_1 = require("../icons/IconPostAdd");
const IconVisibility_1 = require("../icons/IconVisibility");
const IconVisibilityOff_1 = require("../icons/IconVisibilityOff");
const NewBookingDropdown_1 = require("../new-booking-dropdown/NewBookingDropdown");
const ResourceIconWithColor_1 = require("../resource-icon-with-color/ResourceIconWithColor");
const Spinner_1 = require("../spinner/Spinner");
require("./ManagerPageDashboard.scss");
const ManagerPageDashboard = (props) => {
    const [bookings, setBookings] = (0, react_1.useState)([]);
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const config = (0, configContext_1.useConfig)();
    const firestore = (0, useFirestore_1.useFirestore)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const [dateFilter, setDateFilter] = (0, useQueryString_1.useQueryStringForDate)("date", (0, startOfToday_1.default)());
    (0, react_1.useEffect)(() => {
        setIsLoading(true);
        const unsubscribeQuery = (0, firestore_1.onSnapshot)((0, firestore_1.query)((0, firestore_1.collection)(firestore, "bookings"), (0, firestore_1.where)("tenantId", "==", config.tenantId), (0, firestore_1.where)("status", "in", BookingStatus_1.BookingStatus.allBusyStatus.map((s) => s.name)), (0, firestore_1.where)("start", ">=", (0, startOfDay_1.default)(dateFilter)), (0, firestore_1.where)("start", "<=", (0, endOfDay_1.default)(dateFilter)), (0, firestore_1.orderBy)("start", "asc")), (querySnapshot) => {
            const bookings = bookingFactory.createAllFromFirestore(querySnapshot.docs, config);
            setBookings(bookings);
            setIsLoading(false);
        }, (err) => {
            console.error(err);
        });
        return () => unsubscribeQuery();
    }, [dateFilter]);
    let content;
    if (isLoading) {
        content = react_1.default.createElement(Spinner_1.Spinner, { className: "my-3 mx-auto" });
    }
    else {
        const bookingsGroupedByResource = (0, groupBy_1.default)(bookings, (booking) => booking.getResourceId());
        // Sort in the order the resources appear in the config.
        const configOrderedResourceIds = config.resources.map((r) => r.id);
        const sortedResourceIds = (0, keys_1.default)(bookingsGroupedByResource).sort((a, b) => configOrderedResourceIds.indexOf(a) -
            configOrderedResourceIds.indexOf(b));
        const cards = [];
        sortedResourceIds.forEach((resourceId) => {
            const configResource = config.getResourceById(resourceId);
            const groupedBookings = bookingsGroupedByResource[resourceId];
            cards.push(react_1.default.createElement(Col_1.default, { key: resourceId, sm: 4, className: "mb-4" },
                react_1.default.createElement(Card_1.default, null,
                    react_1.default.createElement(Card_1.default.Header, { className: "d-flex w-100 justify-content-between" },
                        react_1.default.createElement("h5", { className: "mb-0" },
                            react_1.default.createElement(ResourceIconWithColor_1.ResourceIconWithColor, { resource: configResource !== null && configResource !== void 0 ? configResource : resourceId })),
                        react_1.default.createElement("small", null, configResource === null || configResource === void 0 ? void 0 : configResource.floor)),
                    react_1.default.createElement(Card_1.default.Body, null,
                        react_1.default.createElement(ListGroup_1.default, null, groupedBookings.map((booking) => {
                            var _a;
                            const addonTypes = [];
                            if (booking instanceof CustomerBooking_1.CustomerBooking) {
                                for (let addonType in booking.getAddonsGroupedByType()) {
                                    addonTypes.push(addonType);
                                }
                            }
                            return (react_1.default.createElement(ListGroup_1.default.Item, { key: booking.id, action: true, onClick: () => {
                                    navigate(`/manager/${config.tenantId}/bookings/${booking.reference}/`);
                                } },
                                react_1.default.createElement("div", { className: "d-flex w-100 justify-content-between" },
                                    react_1.default.createElement("span", null,
                                        dateUtils.formatTime(booking.start),
                                        " -",
                                        " ",
                                        dateUtils.formatTime(booking.end)),
                                    booking.publicDisplay ? (react_1.default.createElement(IconVisibility_1.IconVisibility, { className: "text-secondary" })) : (react_1.default.createElement(IconVisibilityOff_1.IconVisibilityOff, { className: "text-secondary" }))),
                                react_1.default.createElement("h6", { className: "mb-1" }, booking.title),
                                react_1.default.createElement("p", { className: "mb-1" }, booking.subtitle),
                                booking instanceof CustomerBooking_1.CustomerBooking ? (react_1.default.createElement("small", null,
                                    react_1.default.createElement(IconEmojiPeople_1.IconEmojiPeople, null),
                                    " ",
                                    booking.contact.name,
                                    react_1.default.createElement("br", null),
                                    react_1.default.createElement(IconPeople_1.IconPeople, null),
                                    " ",
                                    booking.people,
                                    " ",
                                    booking.people === 1 ? "Person" : "Personen",
                                    react_1.default.createElement("br", null),
                                    addonTypes.length > 0 && (react_1.default.createElement(react_1.default.Fragment, null,
                                        react_1.default.createElement(IconPostAdd_1.IconPostAdd, null),
                                        " ",
                                        addonTypes.join(", "))))) : (react_1.default.createElement("small", null,
                                    react_1.default.createElement(IconEmojiPeople_1.IconEmojiPeople, null),
                                    " ", (_a = booking.createdBy) === null || _a === void 0 ? void 0 :
                                    _a.name))));
                        }))))));
        });
        if (cards.length > 0) {
            content = react_1.default.createElement(Row_1.default, null, cards);
        }
        else {
            content = react_1.default.createElement(Alert_1.default, { variant: "info" }, "Keine Buchung an diesem Tag");
        }
    }
    return (react_1.default.createElement(Container_1.default, { fluid: true, className: "manager-page-dashboard" },
        react_1.default.createElement("div", { className: "d-flex align-items-center justify-content-between mt-4 mb-4" },
            react_1.default.createElement("h1", { className: "text-nowrap mb-0" },
                "Tages\u00FCbersicht",
                react_1.default.createElement(OverlayTrigger_1.default, { placement: "right", overlay: react_1.default.createElement(Tooltip_1.default, { id: "title-tooltip" }, "Buchungen in der Tages\u00FCbersicht.") },
                    react_1.default.createElement("span", { className: "text-secondary pl-1 no-print", style: { fontSize: "20px" } },
                        react_1.default.createElement(IconHelpOutline_1.IconHelpOutline, null)))),
            react_1.default.createElement(NewBookingDropdown_1.NewBookingDropdown, { className: "no-print", onNewBookingSelected: (resource) => {
                    const date = dateUtils.formatDateIso(dateFilter);
                    navigate(`/manager/${config.tenantId}/bookings/new/?resourceId=${resource.id}&date=${date}`);
                } })),
        react_1.default.createElement(BookingFilters_1.BookingFilters, { className: "mb-3", view: "day", date: dateFilter, onDateChange: setDateFilter, minDate: dateUtils.defaultMinDate, maxDate: dateUtils.defaultMaxDate }),
        content));
};
exports.ManagerPageDashboard = ManagerPageDashboard;
